<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  data: object | string | number | Array<{key: string, val: string | number}>
  cellConfig: Object,
  tableConfig?: Object,
}

const props = defineProps<Props>()

const value = computed(() => {
  if (Array.isArray(props.data)) return props.data[0]?.val
  if(typeof props.data != 'object' || Object.keys(props.data).length === 0 ) return
  return props.data
})
</script>

<template>
  <div class="table-cell listing-statistic-cell">
    <div class="flex">
      <div class="statistic-item">
        <span class="key">Lượt xem</span>
        <span class="val">{{ value }}</span>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
